import { render, staticRenderFns } from "./ChatSessionHeader.vue?vue&type=template&id=a037014a&scoped=true"
import script from "./ChatSessionHeader.vue?vue&type=script&lang=js"
export * from "./ChatSessionHeader.vue?vue&type=script&lang=js"
import style0 from "./ChatSessionHeader.vue?vue&type=style&index=0&id=a037014a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a037014a",
  null
  
)

export default component.exports